import axios from 'axios';
import Errors from '../components/FormItems/error/errors';
import { push } from 'connected-react-router';
import { doInit } from 'actions/auth';
import { toast } from 'react-toastify';
import {t} from 'i18next';

const actions = {
  doNew: () => {
    return {
      type: 'USERS_FORM_RESET',
    };
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: 'USERS_FORM_FIND_STARTED',
      });

      axios.get(`/users/${id}`).then(res => {
        const record = res.data;

        dispatch({
          type: 'USERS_FORM_FIND_SUCCESS',
          payload: record,
        });
      })
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: 'USERS_FORM_FIND_ERROR',
      });

      dispatch(push('/admin/users'));
    }

  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: 'USERS_FORM_CREATE_STARTED',
      });

      await axios.post('/users/', { ...values });
      dispatch({
        type: 'USERS_FORM_CREATE_SUCCESS',
      });

      toast.success(t('User created'));
      dispatch(push('/admin/users'));

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: 'USERS_FORM_CREATE_ERROR',
      });
    }
  },

  doUpdate: (id, data, isProfile) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: 'USERS_FORM_UPDATE_STARTED',
      });

      await axios.post(`/users/${id}`, data);

      dispatch({
        type: 'USERS_FORM_UPDATE_SUCCESS',
      });

      if (isProfile) {
        dispatch(doInit());
        toast.success(t('Profile updated'));
      } else {
        toast.success(t('User updated'));
      }
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: 'USERS_FORM_UPDATE_ERROR',
      });
    }
  },

  doChangePassword: (id, password) => async (dispatch) => {
    try {
      dispatch({
        type: 'USERS_FORM_UPDATE_STARTED',
      });
      await axios.post(`/users/${id}`, { plainPassword: password });
      dispatch({
        type: 'USERS_FORM_UPDATE_SUCCESS',
      });

      toast.success(t('Password has been updated'));
      dispatch(push('/app/main'));

    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: 'USERS_FORM_CREATE_ERROR',
      });
    }
  },
};

export default actions;
